import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  CustomInput,
} from 'reactstrap';
import { MyPhoto } from './';
import { Title, MobileInput, PageHeader } from '../Shared';
import { accountActions, authActions } from '../_actions';
import { EmailInput } from '../Account';
import { inputValidation } from '../_helpers';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';

function MyAccount(props) {
  const { myAccount, getMyAccount } = props;
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userName, setUserName] = useState('');
  const [smsNotifications, setSmsNotifications] = useState(null);
  const [emailNotifications, setEmailNotifications] = useState(null);
  const [emailState, setEmailState] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberState, setPhoneNumberState] = useState(null);

  useEffect(() => {
    getMyAccount();
  }, [getMyAccount]);

  const validateEmail = (value) => {
    setEmailState(inputValidation.email(value));
  };

  const validatePhoneNumber = (value) => {
    setPhoneNumberState(inputValidation.mobile(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      firstName,
      lastName,
      email,
      userName,
      phoneNumber,
      emailNotifications: myAccount.emailNotifications,
      smsNotifications: myAccount.smsNotifications,
    };

    if (smsNotifications !== null) {
      data.smsNotifications = smsNotifications;
    }
    if (emailNotifications !== null) {
      data.emailNotifications = emailNotifications;
    }
    if (!isEmpty(data)) {
      props.updateAccount({ ...data });
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    props.logout();
  };

  return (
    <Fragment>
      <Title text="My Account" />
      <PageHeader>
        <Row>
          <Col>
            <h4 className="orange-title text-center">My Account</h4>
          </Col>
        </Row>
      </PageHeader>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              <Row form>
                <Col xs={12}>
                  <FormGroup>
                    <Input
                      className="rounded-input"
                      placeholder="First name:"
                      id="firstName"
                      name="firstName"
                      type="text"
                      onChange={(e) => setFirstName(e.target.value)}
                      defaultValue={myAccount && myAccount.firstName}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Input
                      className="rounded-input"
                      placeholder="Surname:"
                      id="lastName"
                      name="lastName"
                      type="text"
                      onChange={(e) => setLastName(e.target.value)}
                      defaultValue={myAccount && myAccount.lastName}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col xs={12}>
                  <FormGroup>
                    <Input
                      className="rounded-input"
                      placeholder="Username:"
                      id="userName"
                      name="userName"
                      type="text"
                      onChange={(e) => setUserName(e.target.value)}
                      defaultValue={myAccount && myAccount.userName}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <EmailInput
                    handleChange={setEmail}
                    email={myAccount && myAccount.email}
                    validateEmail={validateEmail}
                    validation={emailState}
                  />
                </Col>
              </Row>
              <Row form>
                <Col xs={12}>
                  <MobileInput
                    handleChange={setPhoneNumber}
                    phoneNumber={myAccount && myAccount.phoneNumber}
                    validatePhoneNumber={validatePhoneNumber}
                    validation={phoneNumberState}
                  />
                </Col>
                {myAccount && (
                  <Fragment>
                    <Col xs={12}>
                      <FormGroup>
                        <CustomInput
                          defaultChecked={myAccount.emailNotifications}
                          onClick={(e) =>
                            setEmailNotifications(e.target.checked)
                          }
                          type="checkbox"
                          label="Email Notifications"
                          id="email-notifs"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <FormGroup>
                        <CustomInput
                          defaultChecked={myAccount.smsNotifications}
                          onClick={(e) => setSmsNotifications(e.target.checked)}
                          type="checkbox"
                          label="SMS Notifications"
                          id="sms-notifs"
                        />
                      </FormGroup>
                    </Col>
                  </Fragment>
                )}
              </Row>
              <Button block color="primary">
                Update
              </Button>
            </Form>
          </Col>
        </Row>
        <Row className={'pt-4'}>
          <Col>
            <p
              className={'text-center'}
              style={{ lineHeight: '0.8rem', fontSize: '0.8rem' }}
            >
              <small>
                <Link
                  to={`/`}
                  onClick={handleLogout}
                  style={{ textDecoration: 'underline' }}
                >
                  Logout of my account
                </Link>
              </small>
            </p>
          </Col>
        </Row>
      </Container>
      <PageHeader className="my-4"></PageHeader>
      <Container className="my-4 d-flex justify-content-center">
        <Row>
          <MyPhoto />
        </Row>
      </Container>
    </Fragment>
  );
}
function mapState(state) {
  const { myAccount } = state.account;
  return { myAccount };
}

const mapDispatch = {
  logout: authActions.logout,
  getMyAccount: accountActions.myAccount,
  updateAccount: accountActions.updateAccount,
};

const connectedMyAccount = connect(mapState, mapDispatch)(MyAccount);
export { connectedMyAccount as MyAccount };
